import { Component, OnInit } from '@angular/core';
import { RoleManagementService } from './role-management.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PermissionManagementService } from '../permission-management/permission-management.service';
import { TranslateService } from '@ngx-translate/core';

export const columns = [
  { key: 'name', name: 'ROLE_NAME', visible: true },
  { key: 'description', name: 'ROLE_DESCRIPTION', visible: true },
  { key: 'createTime', name: 'CREATE_TIME', visible: true },
  { key: 'updateTime', name: 'UPDATE_TIME', visible: true },
];

@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss']
})
export class RoleManagementComponent implements OnInit {

  dataSource: any[] = [];
  columns: any[] = columns;
  widthConfig = ['24%','24%','24%','24%','120px'];
  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
    pageSizeOptions: [10, 20, 50],
  };
  
  isVisible = false;
  validateModuleForm!: FormGroup;

  permissionList: any[] = [];
  permissionModalVisible = false;
  permissionDetail = {
    roleId: 0,
    permissionIds: [],
  };

  isSpinning = false;

  constructor(
    private service: RoleManagementService,
    private permissionService: PermissionManagementService,
    private fb: FormBuilder,
    private message: NzMessageService,
    private translate: TranslateService
    ) { }

  ngOnInit(): void {
    this.getPermissionList();
    this.getList();
    this.validateModuleForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(32)]],
      description: [null, []],
      id: [null, []],
    });
  }

  getList() {
    this.isSpinning = true;
    this.service.getTableList({ size: this.pagination.pageSize, current: this.pagination.pageIndex }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { rows, total } = rtnData;
        this.dataSource = rows;
        this.pagination.total = total;
      }
      this.isSpinning = false;
    });
  }

  onEdit(row: any) {
    this.isSpinning = true;
    this.service.addOrUpdate(row).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
    this.onCancel();
  }

  onDelete(row: any) {
    this.isSpinning = true;
    this.service.delete(row.id).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.getList();
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
      }
      this.isSpinning = false;
    });
  }

  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onEditRole(row: any) {
    const { name, description, id } = row;
    this.validateModuleForm.setValue({
      name, description, id
    });
    this.isVisible = true;
  }

  onSave() {
    if (this.validateModuleForm.valid) {
      this.onEdit(this.validateModuleForm.value);
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  onCancel() {
    this.validateModuleForm.reset();
    this.isVisible = false;
  }

  getPermissionList() {
    this.permissionService.getPermissionList().subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        this.formatToTreeList(rtnData);
        this.permissionList = rtnData;
      }
    });
  }

  formatToTreeList(list: any[]) {
    list.forEach(node => {
      node.title = node.title || node.name;
      node.key = node.id;
      node.isLeaf = node.subPermissionList.length === 0;
      if (node.subPermissionList && node.subPermissionList.length) {
        node.children = node.subPermissionList;
        this.formatToTreeList(node.children);
      }
    });
  }

  onAddPermission(row: any) {
    this.permissionService.getPermissionByRole(row.id).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        this.permissionDetail.permissionIds = rtnData.map((item: any) => item.id);
      }
      this.permissionDetail.roleId = row.id;
      this.permissionModalVisible = true;
    });
  }

  addPermissionSave() {
    this.isSpinning = true;
    this.service.addPermissionToRole(this.permissionDetail).subscribe(result => {
      const { rtnCode } = result;
      if (rtnCode === 10000) {
        this.message.create('success', this.translate.instant('OPERATION_SUCCESS'));
        this.permissionModalVisible = false;
        this.permissionDetail = {
          roleId: 0,
          permissionIds: [],
        };

      }
    });
    this.isSpinning = false;
  }

  onPermissionChecked(event: any) {
    this.permissionDetail.permissionIds = event.keys;
  }
}
